<template>
  <ys-toggleable-chip
    :id="labelID"
    :label="filter.label"
    :selected="displayActive"
    :disabled="disabled"
    class="filter-pill"
    @change="filterChange"
  >
    <ys-icon slot="icon" icon="ysPlus" />
  </ys-toggleable-chip>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
import '@onxmaps/yellowstone-ui/ys-toggleable-chip'
import '@onxmaps/yellowstone-ui/ys-icon'
import '@onxmaps/yellowstone-ui/icons/ysPlus'
import camelCase from 'lodash/camelCase'

export default {
  props: {
    filter: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['filter-toggled'],
  computed: {
    labelID() {
      return camelCase(this.filter.id)
    },
    displayActive() {
      return this.filter.displayActive
    },
  },
  methods: {
    filterChange() {
      if (!this.disabled) {
        this.$emit('filter-toggled')
      }
    },
  },
}
</script>
